// Same width as the phone rules of `responsive.css`.
const PHONE_QUERY = '(max-width: 767.98px)'
const MARK = 'data-bo-phone-picker'

function onPointerDown(event: Event): void {
  const picker = event.target instanceof Element ? event.target.closest('.ant-picker') : null
  if (!picker) return

  const isPhone = window.matchMedia(PHONE_QUERY).matches
  for (const input of picker.querySelectorAll('input')) {
    if (isPhone) {
      input.setAttribute('inputmode', 'none')
      input.setAttribute(MARK, '')
    } else if (input.hasAttribute(MARK)) {
      // Touched while narrow, now wide (rotated tablet, resized window): typing a date works again.
      input.removeAttribute('inputmode')
      input.removeAttribute(MARK)
    }
  }
}

/**
 * On a phone, tapping a date picker focused its text input, so the soft keyboard came up and covered
 * the calendar (real device, 개발항목 199: 705px of screen left 429px, the calendar ended at 660px).
 *
 * antd has no app-wide switch for this, so the one place is here: right before the focus, the
 * picker's inputs get `inputmode="none"` — still focusable (antd opens the calendar on focus) but
 * the browser shows no keyboard. Dates are picked from the calendar; on a wide screen nothing
 * changes and dates can be typed as before.
 *
 * Call once at start-up. Returns the function that removes the listener.
 */
export function installPhonePickerKeyboardGuard(): () => void {
  // Capture phase: runs before antd's own handlers and before the browser moves the focus.
  document.addEventListener('pointerdown', onPointerDown, true)
  return () => document.removeEventListener('pointerdown', onPointerDown, true)
}
